module.exports = __webpack_public_path__ + "static/media/horizontalIcon.953961ad.svg";